
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import EspacoService from "@/service/v1/sigap/EspacoService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";
import Multiselect from '@vueform/multiselect';

@Options({
    name: "EspacoIndex",
    components: { CardRh, KDataTable, Cadastro, Editar, Multiselect },
})
export default class EspacoIndex extends IndexModelTable {
    public status: any = null;
    public statusId: any = null;
    public nome = "";
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get statusSelect() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public limparFiltros() {
        this.search = "";
        this.nome = "";
        this.statusId = null;
        this.refreshTable();
    }

    created() {
        this.service = new EspacoService();
        this.getStatus();
        this.config.order = [[1, "asc"]];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    nome: this.nome,
                    status: this.statusId,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };

        this.modal_atualizar = 'modal_espaco_update';
        this.config.columns = [
            { data: 'id', name: 'id', class: 'desktop' },
            { data: 'nome', name: 'nome' },
            { data: 'descricao', name: 'descricao' },
            { data: 'observacao', name: 'observacao' },
            { data: 'status', name: 'status' },
        ];

        this.config.columnDefs = [
            {
                targets: 4,
                render: function (row) {
                    return row?.nome ? row.nome.replaceAll('_', ' ') : '';
                }
            }
        ];

        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 5,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-success btn-sm" btn-editar ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_atualizar + '"><i class="fa fa-edit"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $("[btn-editar]").click((btn) => {
            this.dados = null;
            setTimeout(() => {
                this.dados = $(btn.currentTarget).data();
            }, 10);
        });
    }
}
